module.exports = __webpack_public_path__ + "img/icon_02.2c1e910.png";